import React, { useEffect } from 'react'

import { useAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'

import { ACTIONS, shareAnalyticsOptions } from '../analytics'
import { EnableShareModal } from './EnableShareModal'
import { ShareRecapModal } from './ShareRecapModal'
import { StyledModalDrawer } from './styled-components'

export const ShareRecapController = ({
  beneficiaryName,
  onShowShareModal,
  publicEnabled,
  publicUrl,
  recapId,
  showModal,
}: {
  beneficiaryName: string
  onShowShareModal: React.Dispatch<React.SetStateAction<boolean>>
  publicEnabled: boolean
  publicUrl: string
  recapId: string
  showModal: boolean
}): React.ReactElement | null => {
  const { getRemoteString } = useRemoteStrings()
  const analytics = useAnalyticsClient()
  const canMobileShare = Boolean(navigator.share) && publicEnabled && showModal

  useEffect(() => {
    const handleShare = async () => {
      if (canMobileShare) {
        const text = getRemoteString({
          key: 'early.share_settings.share_body.2variable',
          variables: [beneficiaryName, publicUrl],
        })

        try {
          await navigator.share({
            text,
            url: publicUrl,
          })
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            onShowShareModal(false)
          }
        }
      }
    }

    handleShare()
  }, [
    beneficiaryName,
    canMobileShare,
    getRemoteString,
    onShowShareModal,
    publicEnabled,
    publicUrl,
  ])

  if (canMobileShare) {
    return null
  }

  const handleDismiss = () => {
    onShowShareModal(false)
    analytics.track(ACTIONS.BUTTON_TAPPED, {
      ...shareAnalyticsOptions,
      event_description: 'Early Quarterly Recaps Share Modal Dismiss Tapped',
      object_name: 'earlyQuarterlyRecapShareModalDismiss',
    })
  }

  return (
    <StyledModalDrawer isOpen={showModal} onClose={handleDismiss}>
      {publicEnabled ? (
        <ShareRecapModal
          beneficiaryName={beneficiaryName}
          publicUrl={publicUrl}
        />
      ) : (
        <EnableShareModal
          beneficiaryName={beneficiaryName}
          onDismiss={handleDismiss}
          recapId={recapId}
        />
      )}
    </StyledModalDrawer>
  )
}
